import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "searchInput", "section", "sectionTitle", "item"]

  connect() {
    // Close sidebar when clicking outside on mobile
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  toggleSidebar(event) {
    event.stopPropagation()
    const sidebar = document.querySelector('[data-documentation-target="sidebar"]')
    sidebar.classList.toggle('-translate-x-full')
  }

  toggleSection(event) {
    event.preventDefault()
    const sectionId = event.currentTarget.dataset.sectionId
    const section = event.currentTarget.closest('div')
    const chevron = section.querySelector('[data-lucide="chevron-down"]')
    const items = section.querySelector('.mt-1')
    
    // Toggle the chevron rotation
    chevron.classList.toggle('rotate-180')
    
    // Toggle the items visibility
    if (items) {
      items.classList.toggle('hidden')
    }
  }

  filter() {
    const query = this.searchInputTarget.value.toLowerCase().trim()
    
    this.sectionTargets.forEach(sectionEl => {
      const sectionTitle = sectionEl.querySelector('[data-documentation-target="sectionTitle"]').textContent.toLowerCase()
      let sectionHasVisibleItems = false

      const items = sectionEl.querySelectorAll('[data-documentation-target="item"]')
      items.forEach(itemEl => {
        const itemText = itemEl.textContent.toLowerCase()
        
        if (query === "" || itemText.includes(query)) {
          itemEl.style.display = ""
          if (query !== "") sectionHasVisibleItems = true
        } else {
          itemEl.style.display = "none"
        }
      })

      if (query === "") {
        sectionEl.style.display = ""
      } else if (sectionTitle.includes(query) || sectionHasVisibleItems) {
        sectionEl.style.display = ""
        // Auto-expand sections that have matching items
        const items = sectionEl.querySelector('.mt-1')
        const chevron = sectionEl.querySelector('[data-lucide="chevron-down"]')
        if (items && items.classList.contains('hidden')) {
          items.classList.remove('hidden')
          chevron.classList.add('rotate-180')
        }
      } else {
        sectionEl.style.display = "none"
      }
    })
  }

  handleClickOutside(event) {
    const sidebar = document.querySelector('[data-documentation-target="sidebar"]')
    const menuButton = document.querySelector('[data-action="click->documentation#toggleSidebar"]')
    
    if (window.innerWidth < 1024 && // Only on mobile
        !sidebar.contains(event.target) && 
        !menuButton.contains(event.target) &&
        !sidebar.classList.contains('-translate-x-full')) {
      sidebar.classList.add('-translate-x-full')
    }
  }
} 